import React, { useEffect, useRef, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@material-ui/core";
import { AccountTreeOutlined, Close } from "@material-ui/icons";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import CrmTheme from "../../pages/CrmRelationship/theme";
import useStyles from "../../pages/FlowBuilder/styles";

function FlowForm({ open, onClose, flowId, nameWebhook, onSave }) {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  useEffect(() => { if (open) { setName(flowId ? nameWebhook || "" : ""); setError(""); } }, [open, flowId, nameWebhook]);
  const close = () => { if (!lock.current) onClose(); };
  const save = async event => {
    event.preventDefault();
    if (lock.current) return;
    const value = name.trim();
    if (value.length < 2 || value.length > 255) { setError("Informe um nome entre 2 e 255 caracteres."); return; }
    lock.current = true; setBusy(true); setError("");
    try {
      if (flowId) await api.put("/flowbuilder", { flowId, name: value });
      else await api.post("/flowbuilder", { name: value });
      toast.success(flowId ? "Nome do fluxo atualizado." : "Fluxo criado."); if (onSave) onSave(value); onClose();
    } catch (err) {
      if (err.response?.status === 402 && err.response?.data === "exist") setError("Já existe um fluxo com esse nome.");
      else toastError(err);
    }
    finally { lock.current = false; setBusy(false); }
  };
  return <Dialog open={open} onClose={close} fullWidth maxWidth="sm" classes={{ paper: classes.dialog }} aria-labelledby="flow-form-title">
    <DialogTitle id="flow-form-title" className={classes.dialogTitle}><AccountTreeOutlined />{flowId ? "Renomear fluxo" : "Novo fluxo"}<IconButton className={classes.close} aria-label="Fechar fluxo" disabled={busy} onClick={close}><Close /></IconButton></DialogTitle>
    <form onSubmit={save} noValidate className={classes.form}>
      <DialogContent className={classes.content}><TextField id="flow-name" name="name" label="Nome do fluxo" autoFocus fullWidth variant="outlined" size="small" value={name} onChange={event => { setName(event.target.value); setError(""); }} error={Boolean(error)} helperText={error} disabled={busy} inputProps={{ maxLength: 255 }} /></DialogContent>
      <DialogActions className={classes.dialogActions}><Button variant="outlined" disabled={busy} onClick={close}>Cancelar</Button><Button type="submit" variant="contained" color="primary" disabled={busy}>{busy ? "Salvando…" : flowId ? "Salvar nome" : "Criar fluxo"}</Button></DialogActions>
    </form>
  </Dialog>;
}

export default function FlowBuilderModal(props) { return <CrmTheme><FlowForm {...props} /></CrmTheme>; }
